import {cloneElement, isValidElement, ReactElement, ReactNode, useRef} from 'react';
import {styled} from '@mui/material/styles';
import {isFunction} from 'lodash/fp';

import {useElementSize} from 'utils/hooks';

const SContainer = styled('div')`
  height: 100%;
  overflow: hidden;
`;

type Dimensions = {
  width: number;
  height: number;
};

type Props = {
  children: ReactElement | ((dim: Dimensions) => ReactNode);
  className?: string;
};

const ResponsiveBox = ({children, className}: Props) => {
  const ref = useRef(null);
  const dimensions = useElementSize(ref);

  return (
    <SContainer className={className} ref={ref}>
      {isValidElement(children) && cloneElement(children, dimensions)}

      {isFunction(children) && children(dimensions)}
    </SContainer>
  );
};

export default ResponsiveBox;
